import React, { useMemo } from 'react';
import { Box } from '@mui/material';

/**
 * Tiny inline area-chart of revenue per day for the last 30 days. We
 * roll our own instead of pulling a chart lib because this is the only
 * chart on the page and a 50-line SVG carries no dependency weight.
 */
export default function RevenueSparkline({ data, accent = '#422AFB' }) {
  const max = useMemo(() => Math.max(1, ...(data || []).map((d) => d.amount)), [data]);
  const points = useMemo(() => {
    const w = 600;
    const h = 80;
    const stepX = data.length > 1 ? w / (data.length - 1) : w;
    const line = data.map((d, i) => {
      const x = i * stepX;
      const y = h - (d.amount / max) * (h - 6) - 3;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
    const area = `0,${h} ${line} ${w},${h}`;
    return { line, area };
  }, [data, max]);

  return (
    <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      <svg width='100%' height='90' viewBox='0 0 600 90' preserveAspectRatio='none'>
        <polyline points={points.area} fill={`${accent}22`} stroke='none' />
        <polyline points={points.line} fill='none' stroke={accent} strokeWidth='2' />
      </svg>
    </Box>
  );
}
